import React from 'react';
import {connect} from 'react-redux';

import ManualDocumentsVATBoxList from '../manualDocuments/ManualDocumentsVATBoxList';
import ManualDocumentsVATReturnsForm from '../manualDocuments/ManualDocumentsVATReturnsForm';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import {VATBoxType, ReturnPeriodTimeType} from '../../../utils/enums';
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
const log = new Logger('MANUAL_DOCUMENTS_VAT_RETURNS_LINE_EDITOR', LOG_LEVELS.DEBUG);

class ManualDocumentsVATReturnsLineEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            vatBoxList: [],
            selection: {
                totalTaxableBasis: 0,
                totalVAT: 0
            }
        };
        this.addVATBoxHandler = this.addVATBoxHandler.bind(this);
        this.onVATBoxListRowDelete = this.onVATBoxListRowDelete.bind(this);
        this.clearVatBoxList = this.clearVatBoxList.bind(this);
    }

    clearVatBoxList() {
        this.setState({
            vatBoxList: [],
            selection: {
                ...this.state.selection,
                totalTaxableBasis: 0,
                totalVAT: 0
            }
        });
    }

    addVATBoxHandler(vatBoxLineEntry) {
        const vatBoxList = [...this.state.vatBoxList];
        //Update the boxType 
        const vatBoxType = VATBoxType.enumValueOf(vatBoxLineEntry.boxType);
        if(vatBoxType) {
            vatBoxLineEntry.boxType = LANGUAGE_CONTROLLER.format(this.props.languages, vatBoxType.languageString);
        }
        //Update the boxType 
        const returnType = ReturnPeriodTimeType.enumValueOf(vatBoxLineEntry.returnType);
        if(returnType) {
            vatBoxLineEntry.returnType = LANGUAGE_CONTROLLER.format(this.props.languages, returnType.languageString);
        }
        vatBoxList.push(vatBoxLineEntry);
        this.setState({
            vatBoxList: vatBoxList
        });
        this.props.onAddClick(vatBoxList);
    }

    onVATBoxListRowDelete(row) {
        log.debug('onVATBoxListRowDelete(): row: ', row);
        if(row && row.index > -1) {
            let vatBoxList = [...this.state.vatBoxList];
            vatBoxList.splice(row.index, 1);
            this.setState({
                vatBoxList: vatBoxList
            });
            this.props.onRemoveClick(vatBoxList);
        }
    }

    onFieldChangeHandlerFactory(fieldName) {
        log.debug('onFieldChangeHandlerFactory(): fieldName: ', fieldName);
        return (event) => {
            let selection = Object.assign({}, this.state.selection);
            selection[fieldName] = event.target.value;
            this.setState({selection: selection});
            this.props.onInputChange(selection);
        };
    }

    currencyChangeHandler(fieldNameValue) {
        log.debug('currencyChangeHandler(): fieldNameValue: ', fieldNameValue);
        let selection = Object.assign({}, this.state.selection, fieldNameValue);
        this.setState({selection: selection});
        this.props.onInputChange(selection);
    }

    render() {
        log.debug('render(): ', this.props);
        const vatBoxes = this.props.vatBoxes;
        const selection = this.state.selection || {};
        return (
            <div>
                {!this.props.hideTitle &&
                    <h2 className="mt10"><span>{LANGUAGE_CONTROLLER.format(this.props.languages, this.props.titleLanguageString)}</span></h2>
                }
                <ManualDocumentsVATBoxList data={this.state.vatBoxList} onRowDelete={this.onVATBoxListRowDelete} />
                <ManualDocumentsVATReturnsForm onAddClick={this.addVATBoxHandler} vatBoxes={vatBoxes} selectedCountry={this.props.selectedCountry}/>
                <hr/>
                <div className="mt15 mb15">
                    <label><span>{LANGUAGE_CONTROLLER.format(this.props.languages, 'manualDocumentsVATReturnsLineEditor_TotalTaxableBasisOnDocument')}</span>: </label>
                    <FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} rightAlign={false} value={selection.totalTaxableBasis} editOptions={
                        {
                            fieldName: 'totalTaxableBasis',
                            changeHandler: this.currencyChangeHandler.bind(this)
                        }
                    } />
                    <label className="mt10"><span>{LANGUAGE_CONTROLLER.format(this.props.languages, 'manualDocumentsVATReturnsLineEditor_TotalVATOnDocument')}</span>: </label>
                    <FormattedCurrencyValue inputFieldClassName={withFullStoryExclude()} rightAlign={false} value={selection.totalVAT} editOptions={
                        {
                            fieldName: 'totalVAT',
                            changeHandler: this.currencyChangeHandler.bind(this)
                        }
                    } />
                </div>
            </div>
        );
    }
}


ManualDocumentsVATReturnsLineEditor.defaultProps = {
    titleLanguageString: 'VATReturn',
    vatBoxes: [],
    onAddClick: ()=>{},
    onRemoveClick: ()=>{},
    onInputChange: ()=>{},
    selectedCountry: ''
};

function mapStateToProps(state) {
    return {
        languages: state.languages
    }
}

export default connect(mapStateToProps, null, null, { withRef: true })(ManualDocumentsVATReturnsLineEditor);
